
 // Variables for the sorting dropdown elements
 let desktopSorting = document.querySelector('.desktop-sorting');
 if(desktopSorting){
  let sortingDropdownBtn = desktopSorting.querySelector('.select');
  let sortingDropdown = desktopSorting.querySelector('.sorting-dropdown');
  let sortBySelect = document.querySelector('#SortBy');
  let sortLis = sortingDropdown.querySelectorAll('li');
 
 
  // Function to toggle the visibility of the sorting dropdown
  function toggleSortingDropdown() {
      sortingDropdown.classList.toggle('show-desktop-sorting');
  }
  
  // Event listener to toggle the sorting dropdown when the button is clicked
  sortingDropdownBtn.addEventListener('click', toggleSortingDropdown);

  // handle outside click
  document.addEventListener('click', function (event) {
    if (!sortingDropdownBtn.contains(event.target)) {
      sortingDropdown.classList.remove('show-desktop-sorting');
    }
});
 
  document.addEventListener('DOMContentLoaded', function () {
   // Get the <li> elements
   
 
   // Add click event listener to each <li> element
   sortLis.forEach(function (li) {
     li.addEventListener('click', function () {
       
       // Get the data-value attribute
       var dataValue = li.getAttribute('data-value');
 
       // Set the value of the select element with id "SortBy"
      
       sortBySelect.value = dataValue;
       console.log(dataValue);
       // Trigger the change event on the select element
       var event = new Event('change');
       sortBySelect.dispatchEvent(new Event('change'));
       document.querySelector('#FacetSortForm').submit();
     });
   });
 });
 }
 

class FacetsFiltersForm extends HTMLElement {
  constructor() {
      super();
      console.log("facetsFilter");
      // get all filter-containers
      this.filterContainers = this.querySelectorAll('.filter-container');

      // loop through them all
      this.filterContainers?.forEach((filterContainer, index) => {

          let filterHeader = filterContainer.querySelector('.filter-header');
          let filterContent = filterContainer.querySelector('.filter-content');

          // add event listener
          filterHeader.addEventListener('click', (e) => {
              filterContainer.classList.toggle('active');
          });
      });

      this.sortOptions = this.querySelectorAll('[data-mobile-sort]')
      this.activeSortLabels = document.querySelectorAll('[data-active-sort]')
  }

  connectedCallback () {
    if (this.sortOptions.length) {
      Array.from(this.sortOptions).forEach(option => option.addEventListener('change', e => this.onMobileSortChange(option)))
    }
  }
  
  onMobileSortChange (option) {
    const optionValue = option.value

    const dynamicCollection = document.querySelector('dynamic-collection')

    if (!dynamicCollection) return

    dynamicCollection.getCollectionsData(undefined, undefined, undefined, optionValue, true)

    Array.from(this.activeSortLabels).forEach(sortLabel => sortLabel.innerHTML = optionValue)
  }
}
customElements.define('facets-filters-form', FacetsFiltersForm);

/*
  guidline :
  make a component <facets-wrapper> and handle all js logics there



  filter-btn1 == opens filter
  filter-btn2 == closes & opens filter (opens not needed now)

  sorting-btn1  ==  open sorting drawer
  sorting-btn2  ==  closes & opens sorting drawer

  close-menu  == closes whole menu (including filters & sorting)

  open-filter1, close-filter1
  */

  // filters buttons
  let filterBtn1 = document.querySelector('.filter-btn1');
  let filterBtn2 = document.querySelector('.filter-btn2');

  // sorting buttons
  let sortingBtn1 = document.querySelector('.sorting-btn1');
  let sortingBtn2 = document.querySelector('.sorting-btn2');

  // close menu (including filters & sorting)
  let closeMenu = document.querySelector('.close-menu');

  // menu drawers
  let facetsContainer = document.querySelector('.facets-container');
  let facetsBackdrop = document.querySelector('.facets-backdrop-mobile');

  // sorting wrapper
  let sortingWrapper = document.querySelector('.sorting-wrapper');

  // open filter drawer
  filterBtn1.addEventListener('click', () => {
    facetsContainer.classList.add('fs-w1');
    facetsBackdrop.classList.add('fs-w2');
    filterBtn1.firstElementChild.classList.add('fs-half-rotate');
    filterBtn2.firstElementChild.classList.add('fs-half-rotate');
  });

  // handle close menu
  closeMenu.addEventListener('click', () => {
    facetsContainer.classList.remove('fs-w1');
    facetsBackdrop.classList.remove('fs-w2');
    filterBtn1.firstElementChild.classList.remove('fs-half-rotate');
    filterBtn2.firstElementChild.classList.add('fs-half-rotate');
    sortingBtn1.querySelector('.sort-arrow-icon').classList.remove('fs-half-rotate');
    sortingBtn2.querySelector('.sort-arrow-icon').classList.remove('fs-half-rotate');
    sortingWrapper.classList.remove('show-sorting');
  });

  // open sorting drawer
  sortingBtn1.addEventListener('click', () => {
    facetsContainer.classList.add('fs-w1');
    facetsBackdrop.classList.add('fs-w2');
    filterBtn1.firstElementChild.classList.add('fs-half-rotate');
    filterBtn2.firstElementChild.classList.add('fs-half-rotate');

    // rotate arrows
    sortingBtn1.querySelector('.sort-arrow-icon').classList.add('fs-half-rotate');
    sortingBtn2.querySelector('.sort-arrow-icon').classList.add('fs-half-rotate');

    sortingWrapper.classList.toggle('show-sorting');
  });

  // handle toggeling sorting drawer
  sortingBtn2.addEventListener('click', () => {
    sortingBtn2.querySelector('.sort-arrow-icon').classList.toggle('fs-half-rotate');
    sortingBtn1.querySelector('.sort-arrow-icon').classList.toggle('fs-half-rotate');
    sortingWrapper.classList.toggle('show-sorting');
  });

  // close filter drawer
  filterBtn2.addEventListener('click', () => {
    facetsContainer.classList.remove('fs-w1');
    facetsBackdrop.classList.remove('fs-w2');
    filterBtn1.firstElementChild.classList.remove('fs-half-rotate');
    filterBtn2.firstElementChild.classList.remove('fs-half-rotate');
    sortingBtn2.querySelector('.sort-arrow-icon').classList.remove('fs-half-rotate');
    sortingBtn1.querySelector('.sort-arrow-icon').classList.remove('fs-half-rotate');
    sortingWrapper.classList.remove('show-sorting');

  });

  // code below should run on events e.g filters add or remove

  // check for filteres count;
  let activeFacetsContainer = document.querySelector('.active-facets-count');
  let activeFacets = Array.from(activeFacetsContainer.children);
  let activeFacetsCount = [];
  activeFacets.forEach((elem, index) => {
    if (elem.tagName == 'FACET-REMOVE') {
      // push this element to array
      activeFacetsCount.push(index);
    }
  });

  if (activeFacetsCount.length > 0) {
    filterBtn1.lastElementChild.textContent =
      filterBtn1.lastElementChild.textContent + ' ' + `(${activeFacetsCount.length})`;
    filterBtn1.nextElementSibling.style.display = 'inline-block';
  }

  if (activeFacetsCount.length == 0) {
    // handle margin distance for active facets
    activeFacetsContainer.style.marginTop = '8px';
    activeFacetsContainer.style.marginBottom = '8px';

    // show clear filters button when there is at lease one filter
    filterBtn1.nextElementSibling.style.display = 'none';
  }
